module.exports = __webpack_public_path__ + "img/shitang1.8061f8a0.png";